import {
  ContractPackageVersion,
  DeployContractPackageResult,
  FTBalanceTokenResult,
  FTTokenOwnerResult,
  NFTTokenOwnerResult,
  NFTTokenResult,
  PaginatedResponse,
} from '@block-explorer/entities';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { DataResponse } from '../../services';

export interface ContractPackageDetailsRequestParams {
  contractPackageInfoParams: {
    contract_package_hash: string;
    includes: string;
  };
  holdersParams: {
    contractPackageHash: string;
    includes: string;
  };
  nftTokensParams: {
    contract_package_hash: string;
    includes: string;
    is_burned: boolean;
  };
  cep18TokensParams: {
    contractPackageHash: string;
    includes: string;
  };
  ownersParams: {
    contract_package_hash: string;
    includes: string;
  };
  contractVersionParams: {
    contract_package_hash: string;
  };
}

export const getContractPackageDetailsAsync = createAsyncAction(
  'GET_CONTRACT_PACKAGE_DETAILS_REQUEST',
  'GET_CONTRACT_PACKAGE_DETAILS_SUCCESS',
  'GET_CONTRACT_PACKAGE_DETAILS_FAILURE'
)<
  ContractPackageDetailsRequestParams,
  [
    DataResponse<DeployContractPackageResult>,
    PaginatedResponse<FTTokenOwnerResult>,
    PaginatedResponse<NFTTokenResult>,
    PaginatedResponse<FTBalanceTokenResult>,
    PaginatedResponse<NFTTokenOwnerResult>,
    PaginatedResponse<ContractPackageVersion>,
  ],
  any
>();

export const resetContractPackageDetails = createAction(
  'RESET_CONTRACT_PACKAGE_INFO'
)();
